export type Appearance = 'automatic' | 'light' | 'dark'
export type ResolvedTheme = 'light' | 'dark'

const STORAGE_KEY = 'theme'
let boundaryTimer: number | undefined
let initialized = false

export function getAppearancePreference(): Appearance {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === 'light' || stored === 'dark' ? stored : 'automatic'
  } catch {
    return 'automatic'
  }
}

export function resolveTheme(appearance: Appearance, date = new Date()): ResolvedTheme {
  if (appearance !== 'automatic') return appearance
  const hour = date.getHours()
  return hour >= 6 && hour < 18 ? 'light' : 'dark'
}

export function setAppearancePreference(appearance: Appearance) {
  try { localStorage.setItem(STORAGE_KEY, appearance) } catch {
    // Ignore unavailable local storage.
  }
  applyAppearance(appearance)
}

export function initializeAppearance() {
  applyAppearance(getAppearancePreference())
  if (initialized) return
  initialized = true
  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) applyAppearance(getAppearancePreference())
  })
}

function applyAppearance(appearance: Appearance) {
  const theme = resolveTheme(appearance)
  document.documentElement.classList.toggle('dark', theme === 'dark')
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme
  scheduleNextBoundary(appearance)
}

function scheduleNextBoundary(appearance: Appearance) {
  if (boundaryTimer !== undefined) window.clearTimeout(boundaryTimer)
  boundaryTimer = undefined
  if (appearance !== 'automatic') return

  const now = new Date()
  const nextBoundary = new Date(now)
  if (now.getHours() < 6) {
    nextBoundary.setHours(6, 0, 0, 0)
  } else if (now.getHours() < 18) {
    nextBoundary.setHours(18, 0, 0, 0)
  } else {
    nextBoundary.setDate(nextBoundary.getDate() + 1)
    nextBoundary.setHours(6, 0, 0, 0)
  }
  boundaryTimer = window.setTimeout(() => applyAppearance('automatic'), nextBoundary.getTime() - now.getTime())
}
